import { useContext } from "react";
import { classnames } from "lib/helpers";
import DragContainer from "lib/Draggable/DragContainer";
import _ from "lodash";
import DropAnchor from "lib/Draggable/DropAnchor";
import { rootNamespace } from "config";
import { TreeContext } from "pages/Editor";

function Option({ item, path, level }) {
  const { tree, publish, selection } = useContext(TreeContext);
  const selectedPath = _.get(selection, "path");
  // issue #6
  const body = _.get(tree, "body", {});
  function onClick(e) {
    e.stopPropagation();
    publish(rootNamespace, "SELECT", path);
  }
  const component = _.get(body, path);
  const renderId = () => {
    const id = _.get(item, "attribute.id");
    if (id) return " (" + id + ")";
    return null;
  };
  let content = (
    <span className={classnames({ a: path === selectedPath })}>
      {item.name}
      {renderId()}
    </span>
  );
  if (item.children) {
    let children = item.children;
    let options;
    if (Array.isArray(children)) {
      options = children.map((item, i) => (
        <Option
          key={i}
          item={item}
          path={path + ".children." + i}
          level={level + 1}
        />
      ));
    } else {
      options = (
        <Option item={children} path={path + ".children"} level={level + 1} />
      );
    }
    content = (
      <>
        {content}
        <ul>
          {options}
          {Array.isArray(item.children) && (
            <li>
              <DropAnchor
                {...{ path: path + ".children." + item.children.length }}
              />
            </li>
          )}
        </ul>
      </>
    );
  }
  return (
    <li {...{ onClick }}>
      <DragContainer
        {...{ path, component }}
        editable={false}
        draggable={level !== 0}
      >
        {content}
      </DragContainer>
    </li>
  );
}

export default function ComponentTree() {
  // selected, focused component path
  const { tree, selection, publish, subscribe } = useContext(TreeContext);
  // issue #6
  const body = _.get(tree, "body", {});
  return (
    <div className="ct">
      <TreeContext.Provider
        value={{
          tree,
          selection,
          context: "componenttree",
          subscribe,
          publish,
        }}
      >
        <ul>
          {/* issue #6 */}
          {Object.keys(body).map((key) => (
            <Option key={key} item={body[key]} path={key} level={0} />
          ))}
        </ul>
      </TreeContext.Provider>
    </div>
  );
}
